export default "__VITE_ASSET__a1d90e3a__"